import styled, { css } from 'styled-components';
import media from 'styled-media-query';

import { fontSize } from '../../shared/styles/mixins';
import { greyishBrownThree } from '../../shared/styles/colors';

export const Paragraph = styled.p`
	white-space: pre-line;
	${fontSize(20)};
	line-height: 1.4;
	color: ${greyishBrownThree};

	& + & {
		margin-top: 26px;
	}

	& + form {
		margin-top: 30px
	}

	${media.lessThan('991px')`
		${fontSize(18)};

		& + & {
			margin-top: 20px;
		}
	`}

	${media.lessThan('767px')`
		${fontSize(16)};

		& + form {
			margin-top: 22px
		}
	`}

	${(props) => props.featured && css`
		font-weight: 600;
	`}

	${(props) => props.headline && css`
		margin-top: 30px;
		margin-bottom: 26px;
		font-weight: 700;
		color: rgba(0, 0, 0, 0.87);

		${media.lessThan('767px')`
			margin-top: 26px;
			margin-bottom: 22px;
		`}
	`}
	& a:hover {
		text-decoration: underline;
	}
`;
